import CustomFilterLayout from '../../../components/CustomFilter/CustomFilterLayout';
import CustomNavbar from '../../../components/Navs/CustomNavbar';
import CustomCta from '../../../components/StaticBlocks/CustomCta';
import CustomCtaWithEffect from '../../../components/StaticBlocks/CustomCtaWithEffect';
import DynamicTitleDescriptionButton from '../../../components/StaticBlocks/DynamicTitleDescriptionButton';
import GridCardBlock from '../../../components/StaticBlocks/GridCardBlock';
import LogoutButton from '../../../components/StaticBlocks/LogoutButton';
import Paragraph from '../../../components/StaticBlocks/Paragraph';
import TextWithIcon from '../../../components/StaticBlocks/TextWithIcon';
import SubscriptionByCard from '../../../components/Subscription/SubscriptionByCard';
import SubscriptionsList from '../../../components/Subscription/SubscriptionsList';
import WelcomeHeadingTitle from '../../../components/StaticBlocks/WelcomeHeadingTitle';
import MultiWalletCurrencies from '../../../components/Wallet/MultiCurrencies/MultiWalletCurrencies';
import WalletDetails from '../../../components/Wallet/WalletDetails';
import HubspotContactForm from '../../../components/StaticBlocks/HubspotContactForm';
import TallyContactUSForm from '../../../components/StaticBlocks/TallyContactUSForm';
import AccountCustomFilterLayout from '../../../components/AccountCustomFilter/AccountCustomFilterLayout';
import DynamicStoresListView from '../../../components/home/Stores/DynamicStoresListView';
import SingleListingCard from '../../../components/Listings/SingleListingCard';
import Accordion from '../../../components/StaticBlocks/Accordion';
import ComposerDescriptionBlock from '../../../components/StaticBlocks/ComposerDescriptionBlock';
import CustomDynamicCodeBlock from '../../../components/StaticBlocks/CustomDynamicCodeBlock';
import DividerBlock from '../../../components/StaticBlocks/DividerBlock';
import OrderSummary3 from '../../../components/Cart/OrderSummary/OrderSummary3';
import GlobalOrderSummary from '../../../components/Cart/OrderSummary/GlobalOrderSummary';
import GlobalCartItemBox from '../../../components/Cart/CartItemBox/GlobalCartItemBox';
import GlobalCheckoutButton from '../../../components/Cart/Checkout/GlobalCheckoutButton';
import NotificationsList from '../../../components/NotificationsButton/NotificationsList';
import QRScanner from '../../../components/StaticBlocks/QRScanner';
import CardBlockTopImageWithButton from '../../../components/StaticBlocks/CardBlockTopImageWIthButton';
import FeatureCheckList from '../../../components/StaticBlocks/FeatureCheckList';
import MapByListingsAttribute from '../../../components/AllListings/MapByListingsAttribute';
import DynamicAllListings from '../../../components/AllListings/DynamicAllListings';
import ListingCollectionsBlock from '../../../components/Collections/ListingCollectionsBlock';
import AccountCollectionsBlock from '../../../components/Collections/AccountCollectionsBlock';
import DynamicListingsByCategory from '../../../components/AllListings/DynamicListingsByCategory';
import FiltersBySubCategory from '../../../components/CustomFilter/FiltersBySubCategory';
import DynamicShipmentDetails from '../../../components/OrderDetails/DynamicBlocks/DynamicShipmentDetails';
import DynamicShipmentItemsList from '../../../components/OrderDetails/DynamicBlocks/DynamicShipmentItemsList';
import DynamicOrderSummary from '../../../components/OrderDetails/DynamicBlocks/DynamicOrderSummary';
import ImageSLiderBlock from '../../../components/StaticBlocks/ImageSLiderBlock';
import FiltersByDates from '../../../components/CustomFilter/FiltersByDates';
import Listing_Filter from '../../../components/Shared/Listing_Filter';
import DefaultListingFilter from '../../../components/Shared/DefaultListingFilter';
import CategoryDetails from '../../../components/StaticBlocks/CategoryDetails';
import CategoryListings from '../../../components/StaticBlocks/CategoryListings';
import DefaultOpenListingFilter from '../../../components/Shared/DefaultOpenListingFilter';
import AIPromptResponse from '../../../components/StaticBlocks/AIPromptResponse';
import AccountAttributeDetails from '../../../components/DynamicAccountDetails/AccountAttributeDetails';
import AccountLocationWithMap from '../../../components/DynamicAccountDetails/AccountLocationWithMap';
import AccountLocation from '../../../components/DynamicAccountDetails/AccountLocation';
import ImageBlock from '../../../components/StaticBlocks/ImageBlock';
import HeadingBlock from '../../../components/StaticBlocks/HeadingBlock';

export const common_blocks_cases = ({ section }) => {
  const {
    order_number,
    block,
    block_data_key,
    fetch_by,
    data,
    isStatic,
    extra_data,
    styles,
    isEnabled = true,
  } = section || {};
  switch (block) {
    case 'custom_navbar':
      return <CustomNavbar data={data} styles={styles} key={order_number} />;
    case 'multi_wallet_buttons':
      return <MultiWalletCurrencies styles={styles} key={order_number} />;
    case 'wallet_details':
      return <WalletDetails styles={styles} key={order_number} />;
    case 'custom_filter':
      return (
        <CustomFilterLayout
          styles={styles}
          data={data}
          extra_data={extra_data}
          key={order_number}
        />
      );
    case 'custom_account_filter':
      return (
        <AccountCustomFilterLayout
          styles={styles}
          data={data}
          extra_data={extra_data}
          key={order_number}
        />
      );
    case 'grid_card_block_top_image':
      return <GridCardBlock data={data} styles={styles} key={order_number} />;
    case 'dynamic_title_desc_button_top':
      return (
        <DynamicTitleDescriptionButton
          data={data}
          styles={styles}
          key={order_number}
        />
      );
    case 'subscription_by_card':
      return (
        <SubscriptionByCard
          data={data}
          styles={styles}
          extra_data={extra_data}
        />
      );
    case 'text_with_icon':
      return (
        <TextWithIcon data={data} styles={styles} extra_data={extra_data} />
      );
    case 'feature_check_list':
      return (
        <FeatureCheckList data={data} styles={styles} extra_data={extra_data} />
      );
    case 'subscription_list':
      return <SubscriptionsList data={data} styles={styles} />;

    case 'menu_cta':
      return <CustomCtaWithEffect data={data} styles={styles} />;
    case 'logout_cta':
      return <LogoutButton data={data} styles={styles} />;
    case 'welcome_heading_title':
      return (
        <WelcomeHeadingTitle
          data={data}
          styles={styles}
          check_by={'{user_name}'}
        />
      );
    case 'tally_form_block':
      return isEnabled && <TallyContactUSForm data={data} styles={styles} />;
    case 'hubspot_form_block':
      return isEnabled && <HubspotContactForm data={data} styles={styles} />;
    case 'dynamic_all_accounts':
      return (
        <DynamicStoresListView data={data} styles={styles} key={order_number} />
      );
    case 'single_listing_card':
      return (
        <SingleListingCard data={data} styles={styles} key={order_number} />
      );
    case 'accordion_block':
      return <Accordion data={data} styles={styles} key={order_number} />;
    case 'description_with_composer':
      return (
        <ComposerDescriptionBlock
          data={data}
          styles={styles}
          key={order_number}
        />
      );
    case 'dynamic_code_block':
      return (
        <CustomDynamicCodeBlock
          data={data}
          styles={styles}
          key={order_number}
        />
      );
    case 'ai_prompt_to_code':
      return (
        <CustomDynamicCodeBlock
          data={data}
          styles={styles}
          key={order_number}
        />
      );
    case 'divider_block':
      return <DividerBlock styles={styles} />;

    case 'global_order_summary':
      return isEnabled && <GlobalOrderSummary data={data} styles={styles} />;
    case 'global_cart_list':
      return isEnabled && <GlobalCartItemBox data={data} styles={styles} />;
    case 'global_checkout_button':
      return isEnabled && <GlobalCheckoutButton data={data} styles={styles} />;
    case 'notifications_list':
      return isEnabled && <NotificationsList data={data} styles={styles} />;
    case 'qr_scanner':
      return isEnabled && <QRScanner data={data} styles={styles} />;
    case 'card_block_top_image_with_button':
      return (
        <CardBlockTopImageWithButton
          data={data}
          styles={styles}
          key={order_number}
        />
      );
    case 'dynamic_all_listings':
      return isEnabled && <DynamicAllListings data={data} styles={styles} />;

    case 'dynamic_listings_by_category':
      return (
        isEnabled && <DynamicListingsByCategory data={data} styles={styles} />
      );

    case 'listing_collections_block':
      return (
        <ListingCollectionsBlock
          styles={styles}
          data={data}
          key={order_number}
        />
      );
    case 'account_collections_block':
      return (
        <AccountCollectionsBlock
          styles={styles}
          data={data}
          key={order_number}
        />
      );
    case 'filters_by_sub_category':
      return <FiltersBySubCategory data={data} styles={styles} />;
    case 'dynamic_shipment_details':
      return <DynamicShipmentDetails data={data} styles={styles} />;
    case 'dynamic_shipment_items_list':
      return <DynamicShipmentItemsList data={data} styles={styles} />;
    case 'dynamic_order_summary':
      return <DynamicOrderSummary data={data} styles={styles} />;
    case 'image_slider_block':
      return <ImageSLiderBlock data={data} styles={styles} />;
    case 'filters_by_dates':
      return <FiltersByDates data={data} styles={styles} />;
    case 'default_listing_filter':
      return data?.always_show_filter ? (
        <DefaultOpenListingFilter data={data} styles={styles} />
      ) : (
        <DefaultListingFilter data={data} styles={styles} />
      );
    case 'category_details':
      return <CategoryDetails data={data} styles={styles} />;
    case 'category_listings':
      return <CategoryListings data={data} styles={styles} />;
    case 'ai_prompt_response':
      return <AIPromptResponse data={data} styles={styles} />;
    case 'account_attributes_details':
      return <AccountAttributeDetails data={data} styles={styles} />;
    case 'account_location_with_map':
      return <AccountLocationWithMap data={data} styles={styles} />;
    case 'account_location':
      return <AccountLocation data={data} styles={styles} />;
    case 'image_block':
      return (
        data?.enabled && (
          <ImageBlock data={data} styles={styles} key={order_number} />
        )
      );
    case 'heading_title':
      return (
        data?.enabled && (
          <HeadingBlock data={data} styles={styles} key={order_number} />
        )
      );
    case 'paragraph':
      return <Paragraph data={data} styles={styles} />;
    default:
      return <></>;
  }
};
